import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { ConfirmationModalOptions } from 'src/app/shared/models/modal.model';
import { ConstantesService } from 'src/app/shared/services/constantes.service';
import { Router } from '@angular/router';
import { GlobalService } from 'src/app/shared/global.service';
import { UrlService } from 'src/app/shared/services/url.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { AlertService } from 'src/app/shared/services/alert.service';
import { UtilService } from 'src/app/shared/services/util.service';
import { UrlControl } from 'src/app/shared/models/generic.model';
import { PlanCompensatorioModel } from 'src/app/models/planCompensatorio.model';
import { ConfiguracionCompensacion, ConfiguracionCompensacionPK } from 'src/app/models/configuracionCompensacion.model';
import { DominiosService } from 'src/app/shared/services/dominios.service';
import { DetalleDominio } from 'src/app/models/detalleDominio.Model';
import { InscripcionPlanCompensacion } from 'src/app/models/inscripcionPlanCompensacion.model';
import { SolicitudAjusteCompensacion } from 'src/app/models/solicitudAjusteCompensacion.model';
import { SolicitudAjuste } from 'src/app/models/solicitudAjuste.model';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { ModalAprobacionAjusteCompensacion } from '../modal-aprobacion-ajuste-compensacion/modal-aprobacion-ajuste-compensacion.component';

@Component({
    selector: 'app-aprobacion-ajuste-compensacion',
    templateUrl: './aprobacion-ajuste-compensacion.component.html'
})
export class AprobacionAjusteCompensacionComponent implements OnInit, OnChanges {

    @Input() solicitudSeleccionada: SolicitudAjusteCompensacion;
    @Input() inscripcionSeleccionada: InscripcionPlanCompensacion;
    @Input() origen: string;
    @Input() numeroDocumento: string;
    @Output() response = new EventEmitter();

    modalOptionsAprobarInscripcionCompensacion: any;
    modalOptionsDevolverInscripcionCompensacion: any;
    modalOptionsRechazarInscripcionCompensacion: any;

    estadosInscripcion: DetalleDominio[];
    estadoInscripcion: string;

    plan: PlanCompensatorioModel;
    inscripcion: ConfiguracionCompensacion;
    solicitud: SolicitudAjuste;

    codigoTurnoAnterior: number;

    constructor(
        private router: Router,
        private global: GlobalService,
        private urlService: UrlService,
        private spinner: NgxSpinnerService,
        private alertService: AlertService,
        private utilService: UtilService,
        private modalService: NgbModal) {
    }

    ngOnInit() {
        this.modalOptionsAprobarInscripcionCompensacion = new ConfirmationModalOptions(
            'Confirmación', ConstantesService.MENSAJE_CONFIRMACION_APROBACION_INSRIPCION,
            'SI', 'NO', 'fas fa-save', true, false,
            'Aprobar',
            null, 'btn-secondary');
        this.modalOptionsDevolverInscripcionCompensacion = new ConfirmationModalOptions(
            'Confirmación', ConstantesService.MENSAJE_CONFIRMACION_DEVOLUCION_INSRIPCION,
            'SI', 'NO', 'fas fa-save', true, false,
            'Devolver',
            null, 'btn-secondary');
        this.modalOptionsRechazarInscripcionCompensacion = new ConfirmationModalOptions(
            'Confirmación', ConstantesService.MENSAJE_CONFIRMACION_RECHAZO_INSRIPCION,
            'SI', 'NO', 'fas fa-save', true, false,
            'Rechazar',
            null, 'btn-secondary');
        this.obtenerDominio('EstadoInscripcionPlanCompensacion', 'estadosInscripcion');
    }

    ngOnChanges() {
        if (this.solicitudSeleccionada !== undefined) {
            this.solicitud = new SolicitudAjuste();
            this.solicitud.tipoIdFuncionario = this.solicitudSeleccionada.tipoIdFuncionario;
            this.solicitud.numeroIdFuncionario = this.solicitudSeleccionada.numeroIdFuncionario;
            this.consultarPlanCompensacionActual();
        }
    }

    /**
     * Método que guarda los parametros de acuerdo al tipo de parámetro
     * @function obtenerDominio
     * @author dfranco@asesoftware.com
     * @param filtro Dominio a consultar
     * @param lista Variable a la que se va a asignar el resultado
     */
    obtenerDominio(filtro, lista) {
        this.spinner.show();
        const serviceProvider = 'ObtenerDominio';
        const queryParams: Array<[string, string]> = new Array<[string, string]>();
        queryParams.push(['filterBy=detalleDominioPK.nombreDominio', filtro]);
        const url = this.urlService.getUrlTransversal(new UrlControl(serviceProvider, null, queryParams), this.urlService.hostAPI_TRANS);
        this.global.getGenerico(url).subscribe(
            data => {
                this[lista] = data;
                this.spinner.hide();
            }, err => {
                this.catchException('No fue posible cargar los valores inciales de la aplicación');
            }
        );
    }

    /**
     * Método que permite consultar el plan de compensación activo o actual
     * @function consultarPlanCompensacionActual
     * @author dfranco@asesoftware.com
     */
    public consultarPlanCompensacionActual() {
        this.spinner.show();
        const serviceProvider = 'consultarCompensacion';
        const queryParams: Array<[string, string]> = new Array<[string, string]>();
        queryParams.push(['filterBy=estado', DominiosService.ESTADO_PLAN_COMPENSACION_ACTIVO]);
        const url = this.urlService.getUrlFuncionario(new UrlControl(serviceProvider, null, queryParams),
            this.urlService.hostAPI_FUNCIONARIOS);
        this.global.getGenerico(url).subscribe(
            data => {
                this.plan = data[0];
                this.consultarTurnosPlanCompensacionActual();
            }, err => {
                if (err.status === '500') {
                    this.catchException(err.error.message);
                } else {
                    this.catchException('Error al consultar plan de compensación actual');
                }
            }
        );
    }

    /**
     * Método que permite consultar los turnos parametrizados en el plan de compensación actual
     * @author dfranco@asesoftware.com
     * @function consultarTurnosPlanCompensacionActual
     */
    public consultarTurnosPlanCompensacionActual() {
        this.spinner.show();
        const serviceProvider = 'consultarTurnosCompensacion';
        const queryParams: Array<[string, string]> = new Array<[string, string]>();
        queryParams.push(['filterBy=idPlanCompensacion', this.plan.idPlanCompensacion.toString()]);
        const url = this.urlService.getUrlFuncionario(new UrlControl(serviceProvider, null, queryParams),
            this.urlService.hostAPI_FUNCIONARIOS);
        this.global.getGenerico(url).subscribe(
            data => {
                this.plan.listaTurnos = data;
                this.consultarInscripcionFuncionario();
            }, err => {
                if (err.status === '500') {
                    this.catchException(err.error.message);
                } else {
                    this.catchException('Error al consultar turnos asociados al plan de compensación actual');
                }
            }
        );
    }

    /**
     * Método que permite consultar la inscripción del formulario al plan de compensación actual
     * @function consultarInscripcionFuncionario
     * @author dfranco@asesoftware.com
     */
    public consultarInscripcionFuncionario() {
        this.spinner.show();
        const serviceProvider = 'validarInscripcionPlanActual';
        const queryParams: Array<[string, string]> = new Array<[string, string]>();
        queryParams.push(['tipoDocumento', this.solicitudSeleccionada.tipoIdFuncionario]);
        queryParams.push(['numeroDocumento', this.solicitudSeleccionada.numeroIdFuncionario]);
        const url = this.urlService.getUrlFuncionario(new UrlControl(serviceProvider, null, queryParams),
            this.urlService.hostAPI_FUNCIONARIOS);
        this.global.getGenerico(url).subscribe(
            data => {
                if (data !== undefined) {
                    this.inscripcion = data;
                    this.codigoTurnoAnterior = this.inscripcion.configuracionCompensacionPK.turnoIdTurno;
                }
                if (this.estadosInscripcion !== undefined) {
                    const estadosFiltrados = this.estadosInscripcion.filter(
                        estado => estado.detalleDominioPK.nombreDetalleDominio === this.inscripcion.estado);
                    if (estadosFiltrados.length > 0) {
                        this.estadoInscripcion = estadosFiltrados[0].valor;
                    }
                }
                this.consultarAjusteFuncionario();
            }, err => {
                if (err.status === '500') {
                    this.catchException(err.error.message);
                } else {
                    this.catchException('Error al consultar inscripción del funcionario a plan de compensación actual');
                }
            }
        );
    }

    /**
     * Método que permite consultar la solicitud más reciente al plan de compensación actual
     * @function consultarAjusteFuncionario
     * @author dfranco@asesoftware.com
     */
    public consultarAjusteFuncionario() {
        this.spinner.show();
        const serviceProvider = 'validarSolicitudAjustePlanActual';
        const queryParams: Array<[string, string]> = new Array<[string, string]>();
        queryParams.push(['tipoDocumento', this.solicitudSeleccionada.tipoIdFuncionario]);
        queryParams.push(['numeroDocumento', this.solicitudSeleccionada.numeroIdFuncionario]);
        const url = this.urlService.getUrlFuncionario(new UrlControl(serviceProvider, null, queryParams),
            this.urlService.hostAPI_FUNCIONARIOS);
        this.global.getGenerico(url).subscribe(
            data => {
                this.solicitud = data;
                this.spinner.hide();
            }, err => {
                if (err.status === '500') {
                    this.catchException(err.error.message);
                } else {
                    this.catchException('Error al consultar solicitud de ajuste del funcionario a plan de compensación actual');
                }
            }
        );
    }

    /**
     * Método que permite abrir el modal de aprobación de solicitudes de ajuste y capturar la respuesta 
     * que se obtenga al cerrar el mismo
     * @function abrirModaAjuste
     * @author dfranco@asesoftware.com
     */
    public abrirModaAjuste() {
        const modalRef = this.modalService.open(
            ModalAprobacionAjusteCompensacion, { centered: true, size: 'lg' });
        modalRef.componentInstance.idSolicitud = this.solicitud.idSolicitud;
        modalRef.componentInstance.maxHorasCompensacion = this.plan.horasCompensacion - this.inscripcion.horasCompensacion;
        modalRef.result.then((result) => {
            if (result) {
                this.gestionarSolicitud(result.horas, result.estado, result.observaciones);
            }
        }, (reason) => {
            if (reason === ModalDismissReasons.ESC ||
                reason === ModalDismissReasons.BACKDROP_CLICK) { }
        });
    }

    /**
     * Método que aprueba una inscripción a plan de compensación
     * @function aprobarInscripcion
     * @author dfranco@asesoftware.com
     * @param  horas Cantidad de horas a ajustar
     * @param  estado Código del estado que será asignado de acuerdo a la decisión del usuario
     * @param  observaciones Comentarios del jefe
     */
    public gestionarSolicitud(horas: number, estado: string, observaciones) {
        this.solicitud.horasAjuste = horas;
        this.solicitud.respuesta = observaciones;
        this.solicitud.estado = estado;
        this.solicitud.tipoIdJefe = sessionStorage.getItem('tipoDocumento');
        this.solicitud.numeroIdJefe = sessionStorage.getItem('numDocumento');

        this.spinner.show();
        const serviceProvider = 'realizarAjusteCompensacion';
        const url = this.urlService.getUrlFuncionario(new UrlControl(serviceProvider, null, null),
            this.urlService.hostAPI_FUNCIONARIOS);
        this.global.postGenerico(url, this.solicitud).subscribe(
            data => {
                this.spinner.hide();
                if (this.solicitud.estado === DominiosService.ESTADO_AJUSTE_PLAN_COMPENSACION_APROBADO) {
                    this.alertService.generateAlertSuccess(ConstantesService.MENSAJE_EXITO_APROBAR_AJUSTE, '');
                } else if (this.solicitud.estado === DominiosService.ESTADO_AJUSTE_PLAN_COMPENSACION_RECHAZADO) {
                    this.alertService.generateAlertSuccess(ConstantesService.MENSAJE_EXITO_RECHAZAR_AJUSTE, '');
                }
                this.ngOnChanges();
            }, err => {
                this.utilService.cathException(err, this.alertService, this.spinner);

            }
        );
    }

    /**
     * Método que permite regresar al listado de planes de compensación
     * @author dfranco@asesoftware.com
     * @function volver
     */
    volver() {
        this.response.emit();
    }

    /**
     * Método de control de Excepciones
     * @function cathException
     * @author dfranco@asesoftware.com
     * @param  error  mensaje saliente respecto al error ocurrido
     */
    catchException(error) {
        this.utilService.cathException(error, this.alertService, this.spinner);
    }
}